import { render } from "./SideBarCoordenador.vue?vue&type=template&id=3bac5d5a&scoped=true"
import script from "./SideBarCoordenador.vue?vue&type=script&lang=js"
export * from "./SideBarCoordenador.vue?vue&type=script&lang=js"

import "./SideBarCoordenador.vue?vue&type=style&index=0&id=3bac5d5a&lang=scss"
import "./SideBarCoordenador.vue?vue&type=style&index=1&id=3bac5d5a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bac5d5a"]])

export default __exports__